// extracted by mini-css-extract-plugin
export default {"itemsContainer":"Login_itemsContainer__K4Dzd","image":"Login_image__RylC5","button":"Login_button__BAwzO"};